import { useAgentFeatures } from '../agent-features';
import { KnowledgeClients } from './knowledge-clients';
import { CodingAgentsSection as CodingAgentsContent } from './coding-agents';

// The Connections-page section "External MCP": external agents that use
// Poneva knowledge over MCP. It gates itself on the server-owned rollout flag
// (hidden while it loads or when it is off) and owns its data, so a
// connector-provider failure on the same page never hides it.

/** "External MCP": scoped MCP access for any external agent. */
export function KnowledgeClientsSection() {
  const features = useAgentFeatures();
  return features?.knowledgeMcp ? <KnowledgeClients /> : null;
}

/**
 * "Coding agents": the person's own coding agents and their consent. It follows
 * the same server-owned rollout flag as External MCP: while the flag is off or
 * unread nothing renders and the source is never called.
 */
export function CodingAgentsSection() {
  const features = useAgentFeatures();
  return features?.knowledgeMcp ? <CodingAgentsContent /> : null;
}
